export const GET_MATRICES_REQUEST = 'GET_MATRICES_REQUEST'
export const GET_MATRICES_SUCCESS = 'GET_MATRICES_SUCCESS'
export const GET_MATRICES_FAILURE = 'GET_MATRICES_FAILURE'

export const CREATE_MATRIX_REQUEST = 'CREATE_MATRIX_REQUEST'
export const CREATE_MATRIX_SUCCESS = 'CREATE_MATRIX_SUCCESS'
export const CREATE_MATRIX_FAILURE = 'CREATE_MATRIX_FAILURE'

export const GET_MATRIX_REQUEST = 'GET_MATRIX_REQUEST'
export const GET_MATRIX_SUCCESS = 'GET_MATRIX_SUCCESS'
export const GET_MATRIX_FAILURE = 'GET_MATRIX_FAILURE'

export const UPDATE_MATRIX_REQUEST = 'UPDATE_MATRIX_REQUEST'
export const UPDATE_MATRIX_SUCCESS = 'UPDATE_MATRIX_SUCCESS'
export const UPDATE_MATRIX_FAILURE = 'UPDATE_MATRIX_FAILURE'

export const ADD_TRAINEE_REQUEST = 'ADD_TRAINEE_REQUEST'
export const ADD_TRAINEE_SUCCESS = 'ADD_TRAINEE_SUCCESS'
export const ADD_TRAINEE_FAILURE = 'ADD_TRAINEE_FAILURE'

export const CREATE_MODULE_REQUEST = 'CREATE_MODULE_REQUEST'
export const CREATE_MODULE_SUCCESS = 'CREATE_MODULE_SUCCESS'
export const CREATE_MODULE_FAILURE = 'CREATE_MODULE_FAILURE'

export const UPDATE_MODULE_REQUEST = 'UPDATE_MODULE_REQUEST'
export const UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS'
export const UPDATE_MODULE_FAILURE = 'UPDATE_MODULE_FAILURE'

export const EDIT_MODULE_REQUEST = 'EDIT_MODULE_REQUEST'
export const EDIT_MODULE_SUCCESS = 'EDIT_MODULE_SUCCESS'
export const EDIT_MODULE_FAILURE = 'EDIT_MODULE_FAILURE'

export const GET_COMPLIANCE_RATINGS_REQUEST = 'GET_COMPLIANCE_RATINGS_REQUEST'
export const GET_COMPLIANCE_RATINGS_SUCCESS = 'GET_COMPLIANCE_RATINGS_SUCCESS'
export const GET_COMPLIANCE_RATINGS_FAILURE = 'GET_COMPLIANCE_RATINGS_FAILURE'

export const GET_COMPLIANCE_HISTORY_REQUEST = 'GET_COMPLIANCE_HISTORY_REQUEST'
export const GET_COMPLIANCE_HISTORY_SUCCESS = 'GET_COMPLIANCE_HISTORY_SUCCESS'
export const GET_COMPLIANCE_HISTORY_FAILURE = 'GET_COMPLIANCE_HISTORY_FAILURE'

export const DELETE_TRAINEE_REQUEST = 'DELETE_TRAINEE_REQUEST'
export const DELETE_TRAINEE_SUCCESS = 'DELETE_TRAINEE_SUCCESS'
export const DELETE_TRAINEE_FAILURE = 'DELETE_TRAINEE_FAILURE'

export const ARCHIVE_TRAINEE_REQUEST = 'ARCHIVE_TRAINEE_REQUEST'
export const ARCHIVE_TRAINEE_SUCCESS = 'ARCHIVE_TRAINEE_SUCCESS'
export const ARCHIVE_TRAINEE_FAILURE = 'ARCHIVE_TRAINEE_FAILURE'

export const UNARCHIVE_TRAINEE_REQUEST = 'UNARCHIVE_TRAINEE_REQUEST'
export const UNARCHIVE_TRAINEE_SUCCESS = 'UNARCHIVE_TRAINEE_SUCCESS'
export const UNARCHIVE_TRAINEE_FAILURE = 'UNARCHIVE_TRAINEE_FAILURE'

export const UPDATE_TRAINING_RECORD_REQUEST = 'UPDATE_TRAINING_RECORD_REQUEST'
export const UPDATE_TRAINING_RECORD_SUCCESS = 'UPDATE_TRAINING_RECORD_SUCCESS'
export const UPDATE_TRAINING_RECORD_FAILURE = 'UPDATE_TRAINING_RECORD_FAILURE'

export const UPDATE_TRAINEE_REQUEST = 'UPDATE_TRAINEE_REQUEST'
export const UPDATE_TRAINEE_SUCCESS = 'UPDATE_TRAINEE_SUCCESS'
export const UPDATE_TRAINEE_FAILURE = 'UPDATE_TRAINEE_FAILURE'

export const CLEAR_UPDATE = 'CLEAR_UPDATE'



// WEBPACK FOOTER //
// ./src/constants/training_matrix.js